import { TitleH2 } from "../../../Components/CustomUi/titleH2"
import { TitleH3 } from "../../../Components/CustomUi/titleH3"
import { BodySafra, FooterSafra, HeaderSafra, SafraListContainer, SafraListItem, SafraModalContainer } from "./styled"
import Logo from '../../../assets/img/logo.png'
import { LineDivider } from "../../../Components/CustomUi/LineDivider"
import Input from "../../../Components/CustomUi/input"
import { useState } from "react"
import ButtonCustom from "../../../Components/ButtonCustom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import dayjs from "dayjs"
import { SafraItens } from "../../../services/Safra"
import SojaIcone from "../../../assets/svg/soy-bean.svg"
import MilhoIcone from "../../../assets/svg/corn.svg"
// import { useHistory } from "react-router"

interface ModalSafraProps {
    abrir: boolean
    fecharGaveta: () => void
    listarSafra: SafraItens[]
    handleChangeSafra: Function
}

const SojaIcon = ({ color = '#4caf50' }: { color?: string }) => (
    <div style={{
        backgroundColor: color,
        maskImage: `url(${SojaIcone})`,
        WebkitMaskImage: `url(${SojaIcone})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        width: '16px',
        height: '16px',
        display: 'inline-block'
    }} />
)

const MilhoIcon = ({ color = '#ff9800' }: { color?: string }) => (
    <div style={{
        backgroundColor: color,
        maskImage: `url(${MilhoIcone})`,
        WebkitMaskImage: `url(${MilhoIcone})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        width: '16px',
        height: '16px',
        display: 'inline-block'
    }} />
)

const getCulturaIcon = (culturaNome?: string) => {
    const nome = (culturaNome ?? '').toLowerCase()
    if (nome.includes('soja')) return { icon: <SojaIcon />, bg: '#e8f5e9', border: '#4caf50' }
    if (nome.includes('milho')) return { icon: <MilhoIcon />, bg: '#fff8e1', border: '#ff9800' }
    return { icon: <SojaIcon />, bg: '#e8f5e9', border: '#4caf50' }
}



export const ModalSafra: React.FC<ModalSafraProps> = ({ abrir, fecharGaveta, listarSafra, handleChangeSafra }) => {
    const [busca, setBusca] = useState('')
    // const history = useHistory()

    const safrasFiltradas = listarSafra.filter((safra) =>
        (safra.nome ?? '').toLowerCase().includes(busca.toLowerCase())
    )

    // function irParaDashboard() {
    //     fecharGaveta()
    //     history?.push('/home')
    // }

    return (
        <SafraModalContainer open={abrir} onOk={fecharGaveta} onCancel={fecharGaveta} footer={null} closeIcon={false}>
            <HeaderSafra>
                <div>
                    <img src={Logo} alt="Logo" />
                </div>
                <TitleH2>Informe uma safra</TitleH2>
                <TitleH3 style={{ fontWeight: '500' }}>É necessário informar uma safra para acessar essa página!</TitleH3>
            </HeaderSafra>
            <LineDivider />
            <BodySafra>
                <Input placeholder="Buscar safra" value={busca} onChange={setBusca} />

                <SafraListContainer>
                    {safrasFiltradas?.filter(item => item.nome.toLowerCase().includes(busca.toLowerCase())).map((safra) => {
                        const icon = getCulturaIcon(safra?.cultura[0]?.nome)
                        return (
                            <SafraListItem key={safra.cod} onClick={() => handleChangeSafra(safra.cod, safra.nome)}>
                                <div
                                    className="safra-icon"
                                    style={{
                                        backgroundColor: icon.bg,

                                    }}
                                >
                                    {icon?.icon}
                                </div>
                                <div className="safra-info">
                                    <span className="safra-nome">{safra.nome}</span>
                                    <span className="safra-vigencia">
                                        Vigência {dayjs(safra.data_final).format('DD/MM/YYYY')}
                                    </span>
                                </div>
                                <div className="safra-arrow">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                            </SafraListItem>
                        )
                    })}
                </SafraListContainer>
            </BodySafra>
            <LineDivider />
            <FooterSafra>
                <ButtonCustom icon={<FontAwesomeIcon icon={faArrowLeft} />} danger onClick={fecharGaveta}>Voltar</ButtonCustom>
                {/* <ButtonCustom icon={<FontAwesomeIcon icon={faHome} />} type='secondary' onClick={irParaDashboard}>Ir para dashboard</ButtonCustom> */}
            </FooterSafra>
        </SafraModalContainer>
    )
}